import { useCallback } from 'react';

import { useAiAssistantTranscriptionContext } from '../shared/AiAssistantTranscription.context';
import { useAiAssistantProviderGlobalState } from '../shared/useAiAssistantProviderGlobalState';

type TranscriptionStartActionRenderProps = {
   startTranscription: () => Promise<boolean>;
};

type TranscriptionStartActionProps = {
   children: (renderProps: TranscriptionStartActionRenderProps) => JSX.Element;
};

export const TranscriptionStartAction = (props: TranscriptionStartActionProps): JSX.Element => {
   const transcription = useAiAssistantTranscriptionContext();
   const { continuousConfig } = useAiAssistantProviderGlobalState();

   const startTranscription = useCallback(async () => transcription.startSession(true, continuousConfig), [
      transcription,
      continuousConfig,
   ]);

   return props.children({ startTranscription: startTranscription });
};
